import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Flex, Icon, Text } from 'components/ui';
import { colors } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import FreeShippingBannerEN from 'components/Banner/FreeShippingBanner/locales/FreeShippingBanner_en_US';
import FreeShippingBannerFR from 'components/Banner/FreeShippingBanner/locales/FreeShippingBanner_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(FreeShippingBannerEN, FreeShippingBannerFR);

const FreeShippingBanner = () => (
    <Flex
        alignItems='center'
        justifyContent='center'
        backgroundColor={colors.lightBlue}
        paddingY={3}
        gap={2}
    >
        <Icon
            name='truck'
            size={20}
        />
        <Text
            fontSize='sm'
            fontWeight='bold'
            children={getText('freeShippingMessage')}
        />
    </Flex>
);

export default wrapFunctionalComponent(FreeShippingBanner, 'FreeShippingBanner');
